import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { ServiceService } from '../../../../../services/service.service';
import { InsuranceCompanyGridItemObject, InsuranceCompanyGridObject, ServicePaymentGridObject } from '@it2go/types';
import { InsuranceCompanyGqlService } from '../../../../../services/insurance-company.gql-service';

interface State {
    insuranceCompanies: InsuranceCompanyGridObject | null;
    servicePayments: ServicePaymentGridObject | null;
}

const defaultState: State = {
    insuranceCompanies: null,
    servicePayments: null,
};

@Injectable()
export class ServicesPaymentsPageStore extends ComponentStoreFactory<State> {

    insuranceCompanies$ = this.data.insuranceCompanies$.gridItems<InsuranceCompanyGridItemObject>();

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService), inject(InsuranceCompanyGqlService));
    }

}
